import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-clipboard",
  "use": "icon-clipboard-usage",
  "viewBox": "0 0 20 26",
  "content": "<symbol viewBox=\"0 0 20 26\" id=\"icon-clipboard\"><g transform=\"translate(-4)\" fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M6 4v20h16V4H6zm3-2v2h11V2h2a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h3z\" fill-rule=\"nonzero\" /><path d=\"M10 2v2h8V2h-8zm0-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z\" fill-rule=\"nonzero\" /><rect x=\"8\" y=\"8\" width=\"12\" height=\"2\" rx=\"1\" /><rect x=\"8\" y=\"12\" width=\"12\" height=\"2\" rx=\"1\" /><rect x=\"8\" y=\"16\" width=\"12\" height=\"2\" rx=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/icons/icon-clipboard.svg
// module id = 868
// module chunks = 74